
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "48px",
    "height": "48px",
    "viewBox": "0 0 48 48",
    "enable-background": "new 0 0 48 48",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "48",
        "height": "48"
      }
    },
    {
      "tag": "circle",
      "attrsMap": {
        "fill": "#B7C3D7",
        "cx": "24",
        "cy": "24",
        "r": "24"
      }
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "path",
                  "attrsMap": {
                    "fill": "#FFFFFF",
                    "d": "M35.428,24.397c0-0.825-0.272-2.115-0.606-2.867l-2.061-4.636c-0.334-0.754-1.276-1.369-2.093-1.369\n\t\t\t\tH17.89c-0.817,0-1.759,0.615-2.091,1.371l-2.051,4.632c-0.331,0.754-0.604,2.046-0.604,2.869v12.128\n\t\t\t\tc0,0.824,0.668,1.499,1.485,1.499h19.313c0.819,0,1.485-0.675,1.485-1.499V24.397z"
                  }
                }
              ]
            },
            {
              "tag": "g",
              "children": [
                {
                  "tag": "path",
                  "attrsMap": {
                    "fill": "#FFFFFF",
                    "d": "M32.458,10.274c0-0.823-0.668-1.499-1.485-1.499H17.601c-0.817,0-1.485,0.676-1.485,1.499v1.501\n\t\t\t\tc0,0.824,0.668,1.502,1.485,1.502h13.372c0.817,0,1.485-0.678,1.485-1.502V10.274z"
                  }
                }
              ]
            },
            {
              "tag": "g",
              "children": [
                {
                  "tag": "path",
                  "attrsMap": {
                    "fill": "#B7C3D7",
                    "d": "M19.168,29.516h3.152v3.264c0,0.885,0.688,1.598,1.541,1.598h0.898c0.853,0,1.542-0.713,1.542-1.598\n\t\t\t\tv-3.264h3.151c0.854,0,1.545-0.715,1.545-1.597v-0.935c0-0.883-0.69-1.597-1.545-1.597h-3.151v-3.267\n\t\t\t\tc0-0.885-0.689-1.6-1.542-1.6h-0.898c-0.854,0-1.541,0.715-1.541,1.6v3.267h-3.152c-0.852,0-1.543,0.714-1.543,1.597v0.935\n\t\t\t\tC17.625,28.801,18.316,29.516,19.168,29.516z"
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  